var map = {
	"./active_arrow_top.svg": 48,
	"./active_dashboard_ico.svg": 60,
	"./active_product_ico.svg": 107,
	"./active_project_ico.svg": 61,
	"./active_team_ico.svg": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;